import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 찜 목록 삭제
 *
 * Origin: pageNicolasApi.deleteInvenLike
 * API: DELETE /api/v1/inven/like
 */
export async function deleteInvenLike(
  series_uids: string,
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/inven/like',
    {
      method: 'DELETE',
      params: {
        series_uids,
      },
    },
    options
  );
  return response.data;
}
